module.exports = __webpack_public_path__ + "static/media/cookie-angle.03b25e12.png";